import {
  ESettingsActions,
  ESettingsKey,
  IAccountSettings,
  IPaymentsSettings,
  IPolicySettings,
  ISettingsReducer,
  IStoreSettings,
  SettingsActions,
} from 'store/reducers/settingsReducer/settingsTypes';
import { ECommonActions } from 'store/reducers/types';

const initialState: ISettingsReducer = {
  [ESettingsKey.AccountSettings]: { isLoading: true, isUpdated: false } as IAccountSettings,
  [ESettingsKey.PolicySettings]: { isLoading: true, isUpdated: false } as IPolicySettings,
  [ESettingsKey.StoreSettings]: { isLoading: true, isUpdated: false } as IStoreSettings,
  [ESettingsKey.PaymentsSettings]: { isLoading: true, isUpdated: false } as IPaymentsSettings,
};

export default function(state = initialState, action: SettingsActions): ISettingsReducer {
  switch (action.type) {
    case ESettingsActions.GET_SETTINGS:
    case ESettingsActions.GET_SETTINGS_SUCCESS:
    case ESettingsActions.GET_SETTINGS_FAILURE:
    case ESettingsActions.UPDATE_SETTINGS: {
      const { key, ...newState } = action.payload;

      return { ...state, [key]: { ...state[key], ...newState[key] } };
    }

    case ECommonActions.CleanStore: {
      return initialState;
    }

    default:
      return state;
  }
}
